class SwipeBtn extends HTMLElement {

  constructor() {
    super();
    this.initialMouse = 0;
    this.slideMovementTotal = 0;
    this.mouseIsDown = false;
    this.slider = this.querySelector('[data-slider]');
    this.text = this.querySelector('[data-text]');
    this.button = this.querySelector('[data-btn]');
    this.init();
  }

  onMouseDownOrTouchStart(event){
    this.mouseIsDown = true;
    this.classList.remove('swipe-btn--animate')
    this.slideMovementTotal = this.offsetWidth - this.slider.offsetWidth - 2;
    this.initialMouse = event.clientX || event.touches[0].pageX;
  }

  move(elem) {
    let left = +(elem.style.left ?? '0px').replace('px', '');
    let step = (left - 2) / 30;
    function frame() {
      left = left - step;
      elem.style.left = left + 'px'
      if (left <= 2) {
        elem.style.left = '2px'
        clearInterval(id);
      }
    }
    let id = setInterval(frame, 10);
  }

  onMouseUpOrTouchEnd(event){
    if (!this.mouseIsDown) return;
    this.mouseIsDown = false;
    if (+(this.slider.style.left ?? '0px').replace('px', '') < this.slideMovementTotal) {
      this.move(this.slider);
      this.text.style.opacity = 1;
      return;
    }

    this.button.click();

    setTimeout(() => {
      this.move(this.slider);
      this.text.style.opacity = 1;
    }, 1500)
  }

  onMouseMoveOrTouchMove(event){
    if (!this.mouseIsDown) return;
    this.classList.remove('swipe-btn--animate')
    const currentMouse = event.clientX || event.touches[0].pageX;
    const relativeMouse = currentMouse - this.initialMouse;
    const slidePercent = 1 - +(this.slider.style.left ?? '0px').replace('px', '') / this.slideMovementTotal;

    this.text.style.opacity = slidePercent;

    if (relativeMouse <= 0) {
      this.slider.style.left = "2px"
      return;
    }
    if (relativeMouse >= this.slideMovementTotal) {
      this.slider.style.left =  this.slideMovementTotal + "px"
      return;
    }
    this.slider.style.left =  relativeMouse - 10 + "px"

  }
  
  init(){
    this.slider.addEventListener('mousedown', this.onMouseDownOrTouchStart.bind(this));
    this.slider.addEventListener('touchstart', this.onMouseDownOrTouchStart.bind(this));

    this.slider.addEventListener('mouseup', this.onMouseUpOrTouchEnd.bind(this));
    this.slider.addEventListener('touchend', this.onMouseUpOrTouchEnd.bind(this));
    document.body.addEventListener('mouseup', this.onMouseUpOrTouchEnd.bind(this));
    document.body.addEventListener('touchend', this.onMouseUpOrTouchEnd.bind(this));

    document.body.addEventListener('mousemove', this.onMouseMoveOrTouchMove.bind(this));
    document.body.addEventListener('touchmove', this.onMouseMoveOrTouchMove.bind(this));
  }
}

(function() {
  window.intercomSettings = {
    ...(window.intercomSettings || {}),
    app_id: "kongmidq",
    custom_launcher_selector:'[data-open-chat]',
    hide_default_launcher: true
  };
  // window.isIntercomFirstSended = false;
  //
  // Intercom( 'onUnreadCountChange' ,  function ( unreadCount )  {
  //   if(window.isIntercomFirstSended) {
  //     console.log('MESSAGE');
  //     setTimeout(() => {
  //       Intercom('hide')
  //       Intercom('show')
  //     }, 500)
  //   }
  //   window.isIntercomFirstSended = true;
  // } ) ;


  // function onTidioChatApiReady() {
  //   window.tidioChatApi.hide();
  //   window.tidioChatApi.on("close", function() {
  //     window.tidioChatApi.hide();
  //     document.body.style.overflow = 'auto';
  //     document.documentElement.style.overflow = 'auto';
  //   });
  //   window.tidioChatApi.on("messageFromOperator", function() {
  //     window.tidioChatApi.show();
  //     window.tidioChatApi.open();
  //     window.tidioChatApi.track("data-open-chat");
  //   });
  // }
  //
  // const id = setInterval(() => {
  //   if (window.tidioChatApi) {
  //     window.tidioChatApi.on("ready", onTidioChatApiReady);
  //     clearInterval(id)
  //   }
  // }, 100)
  //
  // const btns = document.querySelectorAll("[data-open-chat]");
  // if(btns.length){
  //   btns.forEach(btn => {
  //     btn.addEventListener("click", function() {
  //       window.tidioChatApi.show();
  //       window.tidioChatApi.open();
  //       window.tidioChatApi.track("data-open-chat");
  //     });
  //   })
  // }
})();

customElements.define('swipe-btn', SwipeBtn);

class LocationCheckForm extends HTMLElement {
  constructor() {
    super();
    this.form = this.querySelector('.locationCheckForm');
    this.apiKey = this.form.getAttribute('api-key');
    this.successUrl = this.form.getAttribute('success-url');
    this.fallbackUrl = this.form.getAttribute('fallback-url');
    this.input = this.querySelector('[name="address"]');
    this.init();
  }

  onFormSubmission(event) {
    event.preventDefault();
    let addressValue = this.input.value;
    if(addressValue.trim().length == 4) {
      addressValue = "0" + addressValue;
    }

    const apiKey = this.apiKey || 'f9a60bff2f9542e59443eb918c61aaf7';
    const url = `https://api.opencagedata.com/geocode/v1/json?q=${encodeURIComponent(addressValue)}&key=${apiKey}`;

    fetch(url)
      .then(response => response.json())
      .then(data => {
        if (data.results && data.results.length > 0) {
          const countryCode = data.results[0].components.country_code;
          const suburb = data.results[0].components?.county ?? (data.results[0].components?.city ?? data.results[0].components?.town);

          if (countryCode === 'de' || countryCode === 'at') {
            // Redirect to the German-specific URL
            if(!!suburb) {
              sessionStorage.setItem('collectionsPageSuburbType', (data.results[0].components?.city ?? data.results[0].components?.town) ? 'city' : 'district')
              sessionStorage.setItem('collectionsPageSuburb', suburb.toString())
            } else {
              sessionStorage.removeItem('collectionsPageSuburb')
              sessionStorage.removeItem('collectionsPageSuburbType')
            }
            window.location.href = this.successUrl;
          } else {
            sessionStorage.removeItem('collectionsPageSuburb')
            sessionStorage.removeItem('collectionsPageSuburbType')
            // Redirect to the other URL
            window.location.href = this.fallbackUrl;
          }
        } else {
          // Redirect to the other URL
          console.error('No results found for the given address or ZIP code.');
          window.location.href = this.fallbackUrl;
        }
      })
      .catch(error => console.error('Error:', error));

  }
  
  init() {
    this.form.addEventListener('submit', this.onFormSubmission.bind(this));
  }
}
customElements.define('location-check-form', LocationCheckForm);

(function (){
  const pdpRentalATCs = document.querySelectorAll('[data-atc-rental]');
  if(pdpRentalATCs.length){
    pdpRentalATCs.forEach(btn => {
      btn.addEventListener('click',(e) => {
        e.preventDefault();
        window.showModal('rental-period');
        window.currentRentalATC = btn;
      });
    })
  }
})();